import { Component, ElementRef, ViewChild } from '@angular/core';
import { HighchartsService } from '../piechart/highcharts.service';
import { HttpResponse } from '@angular/common/http';
// import * as Highcharts from 'highcharts';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {
  servicelist: any;
  math = Math;
  data: any;
  connect: any[] = [];
  notconnect: any;
  videostreaming: any;
  videoNotstreaming: any;
  currentTopSelectedValue: any = "connected"
  isLoading: boolean = true;
  connectedStatus: string = 'Connected Status'; // Default status
  /** Dashboard segment toggle: College (default) | School */
  selectedSegment: 'College' | 'School' = 'College';
  constructor(private highcharts: HighchartsService, private spinner: NgxSpinnerService) { }
  ngOnInit() {
    // this.AllServices();
    // Default COLLEGE → segmentwise API for cctvmain-dashboard
    this.getSchoolDashboard('COLLEGE');
    // this.getConnected()
    // console.log('cctvurl', localStorage.getItem("CCTVDashboard"));

  }

  /** Switch College / School CCTV overall cards via segmentwise API. */
  onSegmentChange(segment: 'College' | 'School') {
    if (this.selectedSegment === segment) {
      return;
    }
    this.selectedSegment = segment;
    this.getSchoolDashboard(segment === 'School' ? 'SCHOOL' : 'COLLEGE');
  }

  getDashboard() {
    this.spinner.show();
    this.isLoading = true;
    this.highcharts.getDashboardDetails().subscribe(
      {
        next: (HttpResponse) => {
          if (!HttpResponse) {
            this.spinner.hide();
            return;
          }
          this.data = HttpResponse;
          // this.createChart(HttpResponse);
          // console.log('dashboarddetails', this.data);
          this.isLoading = false;
          setInterval(() => {
            this.spinner.hide();
          }, 1000);

        },
        error: (err: any) => {
          this.isLoading = false;
          // console.log('Error', err);
          this.spinner.hide();
        },
        complete: () => {
          // console.log('completed!');
        }

      }
    )
  }

  getSchoolDashboard(businessType: string = 'COLLEGE') {
    this.spinner.show();
    this.isLoading = true;
    this.highcharts.getSchoolDashboardDetails(businessType).subscribe({
      next: (HttpResponse) => {
        if (!HttpResponse) {
          this.spinner.hide();
          return;
        }
        this.data = HttpResponse;
        this.isLoading = false;
        setInterval(() => {
          this.spinner.hide();
        }, 1000);
      },
      error: () => {
        this.isLoading = false;
        this.spinner.hide();
      }
    });
  }
  getConnected() {
    this.spinner.show();
    this.connectedStatus = 'Connected Status';
    this.currentTopSelectedValue = 'connected'
    this.isLoading = true;
    this.highcharts.getconnecteddetails().subscribe(
      {
        next: (HttpResponse) => {
          if (!HttpResponse) {
            this.spinner.hide();
            return;
          }
          this.connect = HttpResponse;
          // console.log('connected', this.connect);
          this.isLoading = false;
          setInterval(() => {
            this.spinner.hide();
          }, 1000);

        },
        error: (err: any) => {
          this.isLoading = false;
          // console.log('Error connect', err);
          this.spinner.hide();
        },
        complete: () => {
          // console.log('completed!');
        }
      }
    )
  }
  getNotConnected() {
    this.spinner.show();
    this.connectedStatus = 'NotConnected Status';
    this.currentTopSelectedValue = 'not connected'
    this.isLoading = true;
    this.highcharts.getnotconnecteddetails().subscribe(
      {
        next: (HttpResponse) => {
          if (!HttpResponse) {
            this.spinner.hide();
            return;
          }
          this.connect = HttpResponse;
          // console.log('Not Connected', this.connect);
          this.isLoading = false;
          this.spinner.hide();

        }, error: (err: any) => {
          this.isLoading = false;
          // console.log("Error NotConnected", err);
          this.spinner.hide();

        }, complete: () => {
          // console.log('completed!');
        }
      }
    )
  }
  getVideoStreaming() {
    this.spinner.show();
    this.connectedStatus = 'Streaming Status';
    this.currentTopSelectedValue = 'video streaming';
    this.isLoading = true;
    this.highcharts.getvideostreaming().subscribe(
      {
        next: (HttpResponse) => {
          if (!HttpResponse) {
            this.spinner.hide();
            return;
          }
          this.connect = HttpResponse;
          this.spinner.hide();
          this.isLoading = false;
        }, error: (err: any) => {
          this.isLoading = false;
          this.spinner.hide();

        }, complete: () => {
        }
      }
    )
  }
  getNotVideoStreaming() {
    this.spinner.show();
    this.connectedStatus = 'NotStreaming Status';
    this.currentTopSelectedValue = 'Video Not Streaming'
    this.isLoading = true;
    this.highcharts.getvideonotstreaming().subscribe(
      {
        next: (HttpResponse) => {
          if (!HttpResponse) {
            this.spinner.hide();
            return;
          }
          if (HttpResponse == null) {
            this.connect = [];
          } else {
            this.connect = HttpResponse;
          }
          this.isLoading = false;
          this.spinner.hide();

        }, error: (err: any) => {
          this.isLoading = false;
          this.spinner.hide();

        }, complete: () => {
        }
      }
    )
  }
  // createChart(_data: any) {
  //   const chartOptions: any = {
  //     credits: {
  //       enabled: false
  //     },
  //     chart: <any>{
  //       plotBackgroundColor: null,
  //       plotBorderWidth: null,
  //       plotShadow: false,
  //       type: 'pie'
  //     },
  //     title: {
  //       text: ''
  //     },
  //     tooltip: {
  //       pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
  //     },
  //     plotOptions: {

  //       pie: {
  //         innerSize: 100,
  //         depth: 45,
  //         allowPointSelect: true,
  //         cursor: 'pointer',

  //         dataLabels: {
  //           enabled: true,
  //           distance: 10,
  //           format: '{point.percentage:.1f} %',
  //         },

  //         showInLegend: true
  //       }

  //     },
  //     series: [{
  //       name: 'Brands',
  //       colorByPoint: true,
  //       data: [{
  //         name: 'Connected',
  //         y: this.data?.cctvStatusPercentages?.totalConnectedPercentage,
  //         color: '#19C768',
  //         sliced: true,
  //         selected: true
  //       },
  //       {
  //         name: 'Not Connected',
  //         y: this.data?.cctvStatusPercentages.totalNotConnectedPercentage,
  //         color: '#737E85',
  //       },
  //       {
  //         name: 'Streaming',
  //         y: this.data?.cctvStatusPercentages.totalVideoStreamingPercentage,
  //         color: '#9747FF',
  //       },
  //       {
  //         name: 'No Video',
  //         y: this.data?.cctvStatusPercentages.totalVideoNotStreamingPercentage,
  //         color: '#FF333A',
  //       }
  //       ]
  //     }]
  //   };
  //   const chart: any = new Highcharts.Chart('piechart', chartOptions);

  //   console.log(chart);
  // }



  // AllServices() {
  //   if (this.highcharts.getRoles().length == 0) {
  //     this.spinner.show();
  //     this.highcharts.modulebaseurl().subscribe(
  //       {
  //         next: (res) => {
  //           this.servicelist = res;
  //           this.spinner.hide();
  //           console.log('service', this.servicelist);
  //           this.highcharts.setRoles(this.servicelist.moduleBaseURl);
  //           console.log('roleitem', this.highcharts.getRoles());

  //           this.getDashboard()
  //           this.getConnected()

  //         },
  //         error: (error: any) => {
  //           this.spinner.hide();
  //         }
  //       }
  //     )
  //   }
  // }

}